import { PackageX } from 'lucide-react'
import { defineModule } from '@/shell/module-system'
import { StockOutReviewPage } from './pages/StockOutReviewPage'

/**
 * Stock-Out Risk Review (2026-10-12). The weekly Monday review for the
 * purchasing meeting: tiers, overdue POs, blind spots, quotes, decisions.
 * Backend: /api/stock-out-review (page key `stock_out_review`).
 */
export default defineModule({
  id: 'stock-out-review',
  name: 'Stock-Out Review',
  shortName: 'Stock-Out',
  icon: PackageX,
  navSection: 'purchasing',
  navOrder: 30,
  urlNamespace: '/stock-out-review',
  routes: [
    { path: '/', element: StockOutReviewPage, label: 'Stock-Out Review' },
    { path: '/runs/$runId', element: StockOutReviewPage, label: 'Stock-Out Review run' },
  ],
  permissions: ['admin', 'operations', 'operations_logistics', 'purchasing'],
  densityDefault: 'comfortable',
  filterRailDefault: 'collapsed',
  mobileStrategy: 'desktop-only',

  keyboardShortcut: 'g s k',

  commandPaletteEntries: [
    {
      label: 'Go to Stock-Out Review',
      keywords: ['stock', 'stock-out', 'stockout', 'reorder', 'purchasing', 'risk', 'weekly'],
      path: '/',
      group: 'modules',
      shortcut: 'g s k',
    },
  ],
})
